import React from 'react';
import { bool, func, array } from 'prop-types';
// import LandingFeatures from './LandingFeatures';
// import landingFeatures from '../../fixtures/features';

const propTypes = {
  abTest: bool.isRequired,
  isCdn: bool.isRequired,
  onABTestChange: func.isRequired,
  onFeatureChange: func.isRequired,
  selected: array,
};
const defaultProps = {
  abTest: false,
  isCdn: false,
  selected: [],
};

const FlowLandingFeatures = ({ isCdn, onFeatureChange, selected, rawFeatures, children, streamIsTikTok }) => (
  <div className="landings-features">
    {/* {isCdn && (
      <LandingFeatures
        features={landingFeatures}
        selected={selected}
        onFeatureChange={onFeatureChange}
        rawFeatures={rawFeatures}
        streamIsTikTok={streamIsTikTok}
      >
        {children}
      </LandingFeatures>
    )} */}
  </div>
);

FlowLandingFeatures.propTypes = propTypes;
FlowLandingFeatures.defaultProps = defaultProps;

export default FlowLandingFeatures;
